import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import svgUnowLoader from './assets/unow-loader.svg'

import styles from './styles.module.scss'

const AwesomeUnowLoader = ({ alt, className, ...rest }) => (
  <img
    {...rest}
    src={svgUnowLoader}
    alt={alt}
    className={classnames(styles.loader, className)}
    style={{ maxWidth: '130px', maxHeight: '130px' }}
  />
)

AwesomeUnowLoader.defaultProps = {
  alt: 'Chargement…',
  className: undefined,
}

AwesomeUnowLoader.propTypes = {
  alt: PropTypes.string,
  className: PropTypes.string,
}

export default AwesomeUnowLoader
